import { Colors, Router, Utils } from '@lightningjs/sdk';
import lng from '@lightningjs/core';

export default class SettingsMenuItem extends lng.Component {
  static _template() {
    return {
      Link: {
        collision: true,
        h: 85,
        w: 585,
        flex: { direction: 'row', alignItems: 'center' },
        Wrapper: {
          w: 40,
          h: 85,
          flex: { direction: 'row', alignItems: 'center' },
          Icon: {},
        },
        Text: { y: 5 },
      },
      TextBorder: {},
    };
  }

  set item({ id, title, icon, iconWidth, path }) {
    this._item = { id, title, icon, iconWidth, path };
  }

  set index(val) {
    this._index = val;
  }

  get _Text() {
    return this.tag('Text');
  }

  get _Icon() {
    return this.tag('Icon');
  }

  get _TextBorder() {
    return this.tag('TextBorder');
  }

  _handleEnter() {
    Router.navigate(this._item.path);
  }

  _firstEnable() {
    this._Text.patch({
      x: 60,
      text: {
        text: this._item.title,
        fontSize: 40,
      },
      color: Colors('#d6d6d6').get(),
    });
    this._Icon.patch({
      x: 30,
      texture: lng.Tools.getSvgTexture(Utils.asset(this._item.icon), this._item.iconWidth, 41),
    });
  }

  _focus() {
    super._focus();
    this._Text.patch({
      color: Colors('#ffffff').get(),
    });
    this._Icon.patch({
      color: Colors('#ffffff').get(),
    });
    this._TextBorder.patch({
      texture: lng.Tools.getRoundRect(585, 75, 13, 5, Colors('#02AC25').get(), false),
    });
  }

  _unfocus() {
    super._unfocus();
    this._Text.patch({
      color: Colors('#d6d6d6').get(),
    });
    this._Icon.patch({
      color: Colors('#d6d6d6').get(),
    });
    this._TextBorder.patch({
      texture: null,
    });
  }

  // Magic Remote

  _handleHover() {
    this.fireAncestors('$setIndex', this._index);
    this._focus();
  }

  _handleUnhover() {
    this._unfocus();
  }

  _handleClick() {
    this._handleEnter();
  }
}
